import './style.scss';
import React from 'react';
import classnames from 'classnames';

export default function InfoIcon({ className }) {
  return <span className={classnames('info-icon', className)} />;
}
